import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { LOCALES, LOCALE_NAMES, type Locale } from '@/i18n/config';

interface LanguageSwitcherProps {
  align?: 'start' | 'end' | 'center';
}

export function LanguageSwitcher({ align = 'end' }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const currentLocale = i18n.language as Locale;

  const handleLocaleChange = (newLocale: Locale) => {
    if (newLocale === currentLocale) return;
    i18n.changeLanguage(newLocale);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="relative">
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align}>
        {LOCALES.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => handleLocaleChange(lang)}
            className={`${
              currentLocale === lang ? 'bg-accent text-accent-foreground' : ''
            } cursor-pointer`}
          >
            {LOCALE_NAMES[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}